import Vue from 'vue'
import store from '../store'
import { Message, MessageBox } from 'element-ui'
export default {
	getRows(rows, unit = "记录") {
		if (rows.length == 0) {
			Vue.prototype.$message.warning("请选择" + unit);
			return false;
		}
		return rows;
	},
	getOneRow(rows, unit = "记录") {
		rows = this.getRows(rows, unit);
		if (rows == false) return false;
		if (rows.length > 1) {
			Message.warning("只能选择一个" + unit);
			return false;
		}
		return rows[0];
	},
	convertTextarea(text) {
		text = text || '';
		if (text) {
			text = text.replace(/\r\n/g, "<br>")
			text = text.replace(/\n/g, "<br>")
			//替换所有的空格（中文空格、英文空格都会被替换）
			text = text.replace(/\s/g, "&nbsp;")
		}
		return text
	},
	setCookie(c_name, value, expiredays) {
		var exdate = new Date();
		exdate.setDate(exdate.getDate() + expiredays);
		document.cookie = c_name + "=" + value + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
	},
	getCookie(name) {
		var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		if (arr = document.cookie.match(reg)) {
			return (arr[2]);
		} else {
			return false
		}
	},
	delCookie(name) {
		var exp = new Date();
		exp.setTime(exp.getTime() - 1);
		var cval = this.getCookie(name);
		if (cval) {
			document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
		}
	},
	toJson(data) {
		return JSON.parse(JSON.stringify(data))
	},
	calc: {
		add(arg1, arg2) {
			var r1, r2, m;
			try {
				r1 = arg1.toString().split(".")[1].length;
			} catch (e) { r1 = 0 }

			try {
				r2 = arg2.toString().split(".")[1].length;
			} catch (e) { r2 = 0 }
			m = Math.pow(10, Math.max(r1, r2));
			return (arg1 * m + arg2 * m) / m;
		},
		sub(num1, num2) {
			var baseNum, baseNum1, baseNum2, ret;
			var precision;// 精度
			try {
				baseNum1 = num1.toString().split(".")[1].length;
			} catch (e) {
				baseNum1 = 0;
			}
			try {
				baseNum2 = num2.toString().split(".")[1].length;
			} catch (e) {
				baseNum2 = 0;
			}
			baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
			precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
			return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
		},
		mul(arg1, arg2) {
			var m = 0, s1 = arg1.toString(),
				s2 = arg2.toString();
			try {
				m += s1.split(".")[1].length
			} catch (e) { }
			try {
				m += s2.split(".")[1].length
			} catch (e) { }
			return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m
			)
		},
		div(arg1, arg2) {
			var t1 = 0, t2 = 0, r1, r2;
			try {
				t1 = arg1.toString().split(".")[1].length;
			} catch (e) { }

			try {
				t2 = arg2.toString().split(".")[1].length;
			} catch (e) { }
			r1 = Number(arg1.toString().replace(".", ""));
			r2 = Number(arg2.toString().replace(".", ""));
			return (r1 / r2) * Math.pow(10, t2 - t1);

		}
	},

	textareaToHtml(text) {
		text = text || '';
		if (text) {
			text = text.replace(/\r\n/g, "<br>")
			text = text.replace(/\n/g, "<br>")
			//替换所有的空格（中文空格、英文空格都会被替换）
			text = text.replace(/\s/g, "&nbsp;")
		}
		return text
	},
	//
	round(value, point = 2) {
		value = Number(value)
		let a = Math.pow(10, point)
		return Math.round(value * a) / a || 0
	},
	getProgressPercentage(value) {
		value = Number(value) || 0
		if (value > 1) return 100
		return Math.round(value * 100 * 100) / 100 || 0
	},
	//
	getProgress(value) {
		value = Number(value) || 0
		if (value > 1) return 100
		return Math.round(value * 100 * 100) / 100 || 0
	},
	getToday() {
		return this.toDateString(new Date());
	},
	/** 传入开始和结束时间，获取时间间隔 */
	getIntervalDays(start, end) {
		var start_date = this.toDateString(start);
		var end_date = this.toDateString(end);
		// console.log("start_date", start_date)
		// console.log("end_date", end_date)
		var days = Vue.prototype.$dayjs(start_date).diff(end_date, 'day');
		// console.log("days", days)
		return days;
	},
	//获取 x 天前的日期，默认 7 天
	getDayAgo(day = 7) {
		return Vue.prototype.$dayjs().subtract(day, 'day').format('YYYY-MM-DD')
	},
	getAmPm(date) {
		var hours = date.getHours();
		return hours >= 12 ? "下午" : "上午";
	},
	getNowDatetimeString() {
		return this.toDatetimeString(new Date());
	},
	getNowShortDatetimeString() {
		return this.toShortDatetimeString(new Date());
	},
	//根据format格式化日期时间，返回字符串
	toDateStringByFormat(value, format) {
		if (!value) return ''

		let day = Vue.prototype.$dayjs(value);
		var v = day.format(format);
		if (v == "Invalid Date") return "";
		return v;
	},
	//返回YYYY-MM-DD格式的字符串
	toDateString(value) {
		return this.toDateStringByFormat(value, 'YYYY-MM-DD');
	},
	//返回YYYY-MM-DD HH:mm:ss格式的字符串
	toDatetimeString(value) {
		return this.toDateStringByFormat(value, 'YYYY-MM-DD HH:mm:ss');
	},
	//返回YYYY-MM-DD HH:mm格式的字符串
	toShortDatetimeString(value) {
		return this.toDateStringByFormat(value, 'YYYY-MM-DD HH:mm');
	},
	//返回YYYY-MM-DD HH:mm格式的字符串
	toTimeString(value) {
		return this.toDateStringByFormat(value, 'HH:mm');
	},
	getNextWorkDay(date) {
		// Copy date so don't affect original
		var next_day = new Date(date.setDate(date.getDate() + 1))
		// Add days until get not Sat or Sun
		return next_day.getDay() % 6 ? next_day : this.getNextWorkDay(next_day)
	},
	hasUserPath(path) {
		return store.state.user.menus.some((item, index) => {
			return item.fullPath == path
		})
	},
	obj: {
		copyByKey(object, keys) {
			let newObject = {}
			for (let key of keys) {
				newObject[key] = object[key]
			}
			return newObject
		},
		//根据传入的对象，返回一个没有空值的新对象
		removeNullKey(obj) {
			let newObj = {}
			for (let key of Object.keys(obj)) {
				if (obj[key] !== null && obj[key] !== '' && obj[key] !== undefined) {
					newObj[key] = obj[key]
				}
			}
			return newObj
		},
		sortObjectByKey(object, sortKey, sortName = "asc") {
			var obj_arr = Object.entries(object);
			console.log("obj_arr", obj_arr)
			// var sort_keys = obj_keys.sort();
			// if (sortName == "desc") sort_keys = sort_keys.reverse();
		},
		//去除传入的值中非数字的字符
		toNumber(data) {
			data = data.toString();
			return data.replace(/^\D*([0-9]\d*\.?\d{0,4})?.*$/, "$1");
		},
		toInt(data) {
			data = data.toString();
			return data.replace(/^\d*$/, "$1");
		}
	},
	validateRules: {
		//大于
		createGt(num, message) {
			message = message || ('必须大于' + num);
			return (rule, value, callback) => {
				if (value > num) {
					callback()
				} else {
					callback(new Error(message))
				}
			}
		},
		//大于或等于
		createEgt(num, message) {
			message = message || ('必须大于或等于' + num);
			return (rule, value, callback) => {
				if (value >= num) {
					callback()
				} else {
					callback(new Error(message))
				}
			}
		},
		createLt(num, message) {
			message = message || ('必须小于' + num);
			return (rule, value, callback) => {
				if (value < num) {
					callback()
				} else {
					callback(new Error(message))
				}
			}
		},
		//小于或等于
		createElt(num, message) {
			message = message || ('必须小于或等于' + num);
			return (rule, value, callback) => {
				if (value <= num) {
					callback()
				} else {
					callback(new Error(message))
				}
			}
		},
		//数字
		num(rule, value, callback) {
			let regex = /^\d*\.?\d*$/;
			if (regex.test(value)) {
				callback();
			} else {
				callback("请输入数字");
			}
		},
		//正整数
		int(rule, value, callback) {
			let regex = /^\d*$/;
			if (regex.test(value)) {
				callback();
			} else {
				callback("请输入整数");
			}
		},
		//验证浮点数
		decimal(rule, value, callback) {
			let regex = /^(([1-9]\d*)|0)((\d*)(\.\d*)?|0)?$/
			if (value == null || value == '') {
				callback();
			}
			if (regex.test(value)) {
				callback();
			} else {
				callback("请输入数字");
			}
		},
		//身份证验证
		idCard(rule, value, callback) {
			let regex = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
			if (regex.test(value)) {
				callback();
			} else {
				callback("身份证格式不正确");
			}
		},
		//手机号码
		validPhone(rule, value, callback) {
			if (value == null || value == '') {
				callback();
			}
			let regex = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
			if (regex.test(value)) {
				callback();
			} else {
				callback("手机号码格式不正确");
			}
		},
		//密码需包含数字、英文大小写以及特殊字符，长度8-20
		validPwd(rule, value, callback) {
			if (value == null || value == '') {
				callback();
			}
			let regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,20}$/
			if (regex.test(value)) {
				callback();
			} else {
				callback("密码需包含数字、英文大小写以及特殊字符，长度8-20");
			}
		}
	},
	toTreeData(data, childrenIdKey, parentIdKey = "Pid", childrenKey = "children") {
		let rootList = []
		data.forEach((item, index) => {
			if (item[parentIdKey] == 0) {
				rootList.push(item)
			}
		})
		function convertTree(treeData) {
			treeData.forEach(d => {
				data.forEach((item, index) => {
					if (item[parentIdKey] != 0 && item[parentIdKey] == d[childrenIdKey]) {
						if (!d[childrenKey]) d[childrenKey] = []
						d.children.push(item)
					}
				})
				if (d[childrenKey]) convertTree(d[childrenKey])
			})
		}
		convertTree(rootList)
		return rootList
	},
	//传一个文件大小以字节为单位，返回一个对应单位的大小
	getFileSizeText(fileSize) {
		if (fileSize < 1024) {
			return size + " Byte";
		}
		if (fileSize < 1024 * 1024) {
			return this.round(fileSize / 1024, 2) + " Kb";
		}
		if (fileSize < 1024 * 1024 * 1024) {
			return this.round(fileSize / 1024 / 1024, 2) + " Mb";
		}
		return this.round(fileSize / 1024 / 1024 / 1024, 2) + " Gb";
	},
	showMessage(msg = '', type = 'warning') {
		Message({
			message: msg,
			type: type
		});
	}
}